import styled from "styled-components";
import { Typography } from "@mui/material";

interface OverlayProps {
  isOpen: boolean;
}

interface MenuContainerProps {
  isOpen: boolean;
}

export const Overlay = styled.div<OverlayProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1200;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? "visible" : "hidden")};
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
`;

export const MenuContainer = styled.div<MenuContainerProps>`
  position: fixed;
  top: 0;
  right: 0;
  width: 540px;
  height: 100vh;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  z-index: 1300;
  transform: ${({ isOpen }) => (isOpen ? "translateX(0)" : "translateX(100%)")};
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const MenuHeader = styled.div`
  position: relative;
  flex-shrink: 0;
  padding: 32px 16px 0;
  gap: 16px;
`;

export const MenuTitle = styled(Typography)`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  svg {
    font-size: 20px;
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const MenuContent = styled.div`
  flex: 1;
  padding: 16px 20px;
  overflow-y: auto;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.palette.grey[100]};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.palette.grey[400]};
    border-radius: 3px;

    &:hover {
      background: ${({ theme }) => theme.palette.grey[600]};
    }
  }
`;
